export type ShipToAddressFields = {
  ship_to_recipient?: string | null;
  ship_to_address_line_1?: string | null;
  ship_to_address_line_2?: string | null;
  ship_to_address_line_3?: string | null;
  ship_to_city?: string | null;
  ship_to_state?: string | null;
  ship_to_zip?: string | null;
  ship_to_country?: string | null;
};

function trimShipToPiece(value: unknown): string | null {
  if (value == null) return null;
  const text = String(value).trim();
  return text === "" ? null : text;
}

function shipToCountryLine(country: string | null): string | null {
  if (country == null) return null;
  const upper = country.toUpperCase();
  if (upper === "NONE" || upper === "N/A") return null;
  return country;
}

/** Multi-line ship-to block: recipient, address lines, city/state/zip, country (when meaningful). */
export function formatShipToBlock(fields: ShipToAddressFields): string | null {
  const cityStateZip = [fields.ship_to_city, fields.ship_to_state, fields.ship_to_zip]
    .map(trimShipToPiece)
    .filter((piece): piece is string => piece != null)
    .join(" ");

  const parts = [
    trimShipToPiece(fields.ship_to_recipient),
    trimShipToPiece(fields.ship_to_address_line_1),
    trimShipToPiece(fields.ship_to_address_line_2),
    trimShipToPiece(fields.ship_to_address_line_3),
    cityStateZip !== "" ? cityStateZip : null,
    shipToCountryLine(trimShipToPiece(fields.ship_to_country)),
  ].filter((piece): piece is string => piece != null);

  return parts.length > 0 ? parts.join("\n") : null;
}
